import React from "react";
import feathersService from "../../services/feathersService";
import BikeRegister from "../registers/BikeRegister";
import Header from "../common/Header";
import Spinner from "../common/Spinner";
import QRCode from "qrcode";
class RegistryView extends React.Component {
  // state = { tableData:
  //             { type: 'B',
  //               number: '1234567899',
  //               date: "January 1st, 1999",
  //               ownerName: 'OWNER TEST',
  //               code: 'MKQWENK12319231k23',
  //               dni: 33871178,
  //               brand: 'BRAND TEST',
  //               model: 'MODEL TEST',
  //               chasisNumber: 123499922220000123
  //             },
  //             owners: []
  //         }

  state = {
    loading: false,
    data: null,
    error: null,
    qrcode: ""
  };

  fetchRegistryData = async (registryInternalCode, registryHash) => {
    this.setState({ loading: true, data: null, error: null });

    try {
      let result = await feathersService
        .service("api/records-new")
        .find({ query: { registryInternalCode, registryHash } });
      console.log("LOG: RegistryView -> fetchRegistryData -> result", result);
      result = { data: result };
      console.log("LOG: RegistryView -> fetchRegistryData -> result", result);
      if (result.data.length === 1) {
        let entry = result.data[0];
        this.setState(
          { data: entry, loading: false, error: null },
          async () => {
            try {
              let url = await QRCode.toDataURL(window.location.href, {
                scale: 8
              });
              console.log("LOG: RegistryView -> fetchRegistryData -> url", url);
              this.setState({ qrcode: url });
            } catch (err) {
              console.log("LOG: RegistryView -> fetchRegistryData -> err", err);
              this.setState({ qrcode: "" });
            }
          }
        );
      } else {
        this.setState({
          data: null,
          loading: false,
          error: new Error("Data not found"),
          qrcode: ""
        });
      }
    } catch (error) {
      console.log("LOG: RegistryView -> fetchRegistryData -> error", error);
      this.setState({ data: null, loading: false, error, qrcode: "" });
    }
  };

  componentDidMount = () => {
    let {
      match: { params }
    } = this.props;

    this.fetchRegistryData(params.registryInternalCode, params.registryHash);
  };

  componentDidUpdate = prevProps => {
    if (
      this.props.match.params.registryInternalCode !==
        prevProps.match.params.registryInternalCode ||
      this.props.match.params.registryHash !==
        prevProps.match.params.registryHash
    ) {
      this.fetchRegistryData(
        this.props.match.params.registryInternalCode,
        this.props.match.params.registryHash
      );
    }
  };

  render() {
    if (this.state.loading === true || this.state.data === null) {
      return (
        <div className="ui container">
          <Spinner message="cargando..." />
        </div>
      );
    }

    return (
      <div
        style={{
          height: "100vh"
        }}
      >
        <div
          className="ui blue inverted menu large"
          style={{
            backgroundColor: "#194189",
            borderRadius: 0,
            paddingLeft: "100px"
          }}
        >
          <div className="item">
            <img
              className="ui small image"
              src="https://s3.us-east-2.amazonaws.com/storefront-sistel/interface/1/main.png"
              alt=""
            />
          </div>
        </div>
        <div className="ui container" style={{ margin: 50 }}>
          <div
            className="ui segment attached top"
            style={{ backgroundColor: "#F9F9F9" }}
          >
            <Header title="Registro de bicicletas" />
          </div>
          <div className="ui segment attached bottom top large">
            <div className="ui grid two columns stackable very padded">
              <div className="ui column">
                <BikeRegister register={this.state.data} />
              </div>
              <div className="ui column">
                <div id="qrcode">
                  <img src={this.state.qrcode} alt="QR code" />
                </div>
              </div>
            </div>
          </div>
          <div
            className="ui segment attached bottom"
            style={{ backgroundColor: "#F9F9F9" }}
          />
        </div>
      </div>
    );
  }
}

export default RegistryView;
